export const usePrerender = () => {
    const params = new URLSearchParams(window.location.search);
    const isPrerender = !!params.get('prerender');

    return {
        isPrerender,
    };
};
